/**
 * SimplePaper Feature Flag System
 * Simple client-side feature flagging for experiments
 */

window.SP = window.SP || {};
window.SP.FeatureFlags = {
  
  // Feature flag storage
  flags: {},
  
  // Initialize feature flags
  init: function() {
    this.loadFlags();
    this.assignExperimentVariants();
  },
  
  // Load flags from localStorage or set defaults
  loadFlags: function() {
    const stored = localStorage.getItem('sp_feature_flags');
    if (stored) {
      try {
        this.flags = JSON.parse(stored);
      } catch (e) {
        console.warn('Failed to parse stored feature flags, using defaults');
        this.flags = this.getDefaultFlags();
      }
    } else {
      this.flags = this.getDefaultFlags();
    }
  },
  
  // Default flag configuration
  getDefaultFlags: function() {
    return {
      instagram_overlay: 'control', // 'control' or 'overlay'
      debug_mode: false
    };
  },
  
  // Assign experiment variants based on user
  assignExperimentVariants: function() {
    // For Instagram overlay experiment, assign 50/50 split
    if (!this.hasStoredVariant('instagram_overlay')) {
      const variant = this.getExperimentVariant('instagram_overlay', 0.5);
      this.setFlag('instagram_overlay', variant);
      
      // Track experiment assignment with PostHog
      if (typeof posthog !== 'undefined') {
        posthog.capture('posthog_experiment_assignment', {
          exp_key: 'instagram_overlay_v1',
          variant: variant
        });
      }
      
      if (this.flags.debug_mode) {
        console.log(`SP Experiment: instagram_overlay assigned to ${variant}`);
      }
    }
  },
  
  // Check if user has stored variant for experiment
  hasStoredVariant: function(experimentName) {
    return this.flags.hasOwnProperty(experimentName) && 
           this.flags[experimentName] !== 'control';
  },
  
  // Get experiment variant based on user ID or session
  getExperimentVariant: function(experimentName, treatmentRatio = 0.5) {
    // Use a combination of user agent and timestamp for consistent assignment
    const userId = this.getUserId();
    const hash = this.simpleHash(experimentName + userId);
    const normalized = (hash % 1000) / 1000; // 0-1 range
    
    return normalized < treatmentRatio ? 'overlay' : 'control';
  },
  
  // Generate consistent user ID
  getUserId: function() {
    let userId = localStorage.getItem('sp_user_id');
    if (!userId) {
      userId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('sp_user_id', userId);
    }
    return userId;
  },
  
  // Simple hash function for consistent assignment
  simpleHash: function(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  },
  
  // Get flag value
  getFlag: function(flagName) {
    return this.flags[flagName];
  },
  
  // Set flag value
  setFlag: function(flagName, value) {
    this.flags[flagName] = value;
    this.saveFlags();
  },
  
  // Save flags to localStorage
  saveFlags: function() {
    try {
      localStorage.setItem('sp_feature_flags', JSON.stringify(this.flags));
    } catch (e) {
      console.warn('Failed to save feature flags to localStorage');
    }
  },
  
  // Check if feature is enabled
  isEnabled: function(flagName) {
    return this.flags[flagName] === true || this.flags[flagName] === 'overlay';
  },
  
  // Force override flag (for testing)
  override: function(flagName, value) {
    this.setFlag(flagName, value);
    if (this.flags.debug_mode) {
      console.log(`SP Feature Flag Override: ${flagName} = ${value}`);
    }
  },
  
  // Get all current flags (for debugging)
  getAllFlags: function() {
    return { ...this.flags };
  },
  
  // Clear all flags (reset)
  clearFlags: function() {
    localStorage.removeItem('sp_feature_flags');
    localStorage.removeItem('sp_user_id');
    this.flags = this.getDefaultFlags();
  }
};

// Store experiments object for easy access
window.SP.experiments = {};

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.SP.FeatureFlags.init();
    // Make experiments easily accessible
    window.SP.experiments = {
      instagram_overlay: window.SP.FeatureFlags.getFlag('instagram_overlay')
    };
  });
} else {
  window.SP.FeatureFlags.init();
  window.SP.experiments = {
    instagram_overlay: window.SP.FeatureFlags.getFlag('instagram_overlay')
  };
}

// Development helper functions
if (window.location.search.includes('sp_debug=1')) {
  window.SP.FeatureFlags.setFlag('debug_mode', true);
  console.log('SimplePaper Debug Mode Enabled');
  
  // Expose helper functions to console
  window.spDebug = {
    flags: () => window.SP.FeatureFlags.getAllFlags(),
    setFlag: (name, value) => window.SP.FeatureFlags.override(name, value),
    clearFlags: () => window.SP.FeatureFlags.clearFlags(),
    forceOverlay: () => window.SP.FeatureFlags.override('instagram_overlay', 'overlay'),
    forceControl: () => window.SP.FeatureFlags.override('instagram_overlay', 'control')
  };
  
  console.log('Debug helpers available: spDebug.flags(), spDebug.setFlag(name, value), spDebug.forceOverlay(), spDebug.forceControl()');
}